<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title">ESSENTIAL POEMS<br/>(TO FALL IN LOVE WITH)</h1>
<p class="nonindent"><span class="small">PRESENTED BY</span></p>
<h2 class="title">DAISY GOODWIN</h2>
<p class="nonindent1"><img alt="" src="OEBPS/images/9780062031716_L01.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062031716_epub_tp_r1.vue?464863e8